import { render, staticRenderFns } from "./AIsz.vue?vue&type=template&id=d2bdae7e&scoped=true"
import script from "./AIsz.vue?vue&type=script&lang=js"
export * from "./AIsz.vue?vue&type=script&lang=js"
import style0 from "./AIsz.vue?vue&type=style&index=0&id=d2bdae7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bdae7e",
  null
  
)

export default component.exports